<template>
  <div class="homepage">
    <el-container class="all">
      <left></left>
      <el-container class="cow">
        <el-header style="height: auto; padding: 0;">
          <right></right>
        </el-header>
        <el-main style="flex: 1; overflow: hidden; box-sizing: border-box;">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Left from './index/left.vue'
import Right from './index/right.vue'
export default {
  components: { Left, Right }
}
</script>

<style>
/* 全局重置 */
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
}

.homepage {
  height: 100%;
  overflow: hidden;
}

.all {
  height: 100%;
  display: flex;
  flex-direction: row;   /* 左菜单 + 右内容 */
  overflow: hidden;
}

.cow {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: auto;           /* 占满剩余宽度 */
}

.el-header {
  flex-shrink: 0;        /* 头部不压缩 */
}

.el-main {
  flex: 1;
  overflow: hidden;
  padding: 0;
  box-sizing: border-box;
}
</style>
